export default function serializePhotos(photos) {
  return (photos || []).map((photo) => (photo instanceof File ? photo : photo.id));
}
